import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { StrictMode } from "react";
import { ErrorBoundary } from "./components/error-boundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./lib/msalInstance";
import { ThemeProvider } from "@/components/theme/ThemeProvider";

// Filter out auth-related errors in console
const originalConsoleError = console.error;
console.error = function(...args) {
  // Filter out auth-related errors to keep console clean
  if (
    args.length > 0 && 
    typeof args[0] === 'string' && 
    (args[0].includes('auth') ||
     args[0].includes('Auth') ||
     args[0].includes('unhandled rejection'))
  ) {
    console.warn('Suppressed error:', ...args);
    return;
  }
  return originalConsoleError.apply(console, args);
};

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.warn('Intercepted rejection:', event.reason);
  event.preventDefault(); // Prevent browser console messages
  return true;
}, true);

// Clear any storage that might affect the app
localStorage.removeItem('dataverse_use_in_memory');
sessionStorage.removeItem('dataverse_use_in_memory');

// Render the app with Azure authentication via MSAL
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </MsalProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
